module.exports = __webpack_public_path__ + "img/icon-package-price-dark.1e5692b.svg";